// This probably should manage cards, but I'm not familiar enough with react
// to set this up that way
import React, { Component } from 'react'
import './Deck.css';
import Card from './Card';

export default class Deck extends Component {
    constructor () {
        super ();

        this.onClick = this.onClick.bind (this);
        this.createCardElement = this.createCardElement.bind (this);
    }

    onClick (event) {
        // console.log ('deck clicked')
        if (this.props.onClick) {
            this.props.onClick (event);
        }
    }

    // componentDidMount () {
    //     console.log (this.props.children)
    // }

    createCardElement (data, index) {
        if (data === null) { return (<div></div>) }
        if (!data.position) { data.position = {x: 0, y: 0} }

        return (
            <Card
                key={this.props.name + index}
                id={data.id}
                name={data.name}
                img={data.img}
                zIndex={data.zIndex}
                isActive={data.isActive}
                position={data.position}
                isFaceDown={data.isFaceDown}
                isDiscarded={data.isDiscarded}
                isPlacedInColumn={data.isPlacedInColumn}
                isProtected={data.isProtected}
                type={data.type}
                index={index}
                diet={data.diet}
                symbol={data.symbol}
                iceDestroyed={this.props.iceDestroyed}
                facts={data.facts}
                trophicLevel={data.trophicLevel}
                needsIce={data.needsIce}
                validTargets={data.validTargets}
                footer={data.footer}
                blockerText={data.blockerText}
                validTargets={data.validTargets}

                onMouseDown={this.props.onMouseDownOnCard}
                protectedSpeciesName={this.props.protectedSpeciesName}
            />
        )
    }

    render () {
        let className = 'deck' + ' ' + this.props.name;

        if (this.props.type === 'ice deck') { className = 'ice-deck' }

        // console.log (this.props.name, this.props.children)

        return (
            <div className={className}>
                <div className="header-bar">
                    {this.props.name}
                </div>
                <div className="event-holder"  onClick={this.onClick}>
                    {this.props.children.map (this.createCardElement)}
                </div>
            </div>
        )
    }
}
